export default async () => {
  if (process.env.CLIENT) {
    const WebFont = require('webfontloader')
    WebFont.load({
      google: {
        families: ['Material Icons']
      }
    })
  }
}
